import { useCallback } from 'react';
import { generatePath, useHistory } from 'react-router-dom';

import { History } from 'history';

type AbstractRoute<TParams> = string | { index: string; useParams?: () => TParams };
type AbstractRouteParams = Parameters<typeof generatePath>[1];

export function consoleLog(...args: unknown[]) {
  if (process.env.REACT_APP_STAGE !== 'live') {
    // eslint-disable-next-line no-console -- need it here
    console.log(...args);
  }
}

export function sanitizeUrl(url: string): string {
  return url
    .replace(/\/\//, '/')
    .replace(/\/$/, '')
    .replace(/\/index$/, '');
}

export function performNavigate<TParams extends AbstractRouteParams>(
  history: History<any>,
  route: AbstractRoute<TParams>,
  params?: TParams,
) {
  const url = typeof route === 'string' ? sanitizeUrl(route) : route.index;
  consoleLog(`[NAVIGATE]`, params ? generatePath(url, params) : url);
  history.push({ pathname: params ? generatePath(url, params) : url });
}

export function usePerformNavigate(route: string | { index: string }) {
  const history = useHistory();

  return useCallback(() => {
    performNavigate(history, route);
  }, [history, route]);
}
